import { levelLabel } from './minimap.js';
import { uiFormat, uiText } from './text.js';

/** The line that announces the place the player walks into, with its levels when it has some. */
export function placeLine(name: string, level: { min: number; max: number } | undefined): string {
  return level === undefined
    ? uiFormat('Tu entres : {place}', { place: uiText(name) })
    : uiFormat('Tu entres : {place} ({level})', { place: uiText(name), level: levelLabel(level) });
}
